(function () {
  'use strict';

  angular.module('ringbaPortal').component('callTrackingTag', {
    bindings: {
      currentCampaign: '<',
      campaignCountry: '<',
      setCampaignTags: '&',
      onUpdate: '&'
    },
    controller: CallTrackingTagController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/call-tracking-tag/call-tracking-tag.view.html'
  });

  function CallTrackingTagController(
    $scope,
    $translate,
    $uibModal,
    accountsService,
    callTrackingTagService,
    isMobileDevice,
    toaster
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.hideForm = hideForm;
    vm.showForm = showForm;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDeleteTag = confirmDeleteTag;
    vm.cancelDelete = cancelDelete;
    vm.updateTag = updateTag;
    vm.cancelModal = cancelModal;
    vm.openCodeSnippet = openCodeSnippet;
    vm.activateTagActions = activateTagActions;

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      vm.isMobileView = isMobileDevice;
    }

    function onChanges(changes) {
      if (changes.currentCampaign && vm.currentCampaign) {
        vm.tags = vm.currentCampaign.jsTags;
        callTrackingTagService.getCallTrackingTagsLinkedPools(accountsService.currentAccountId, vm.currentCampaign)
          .then(_setTags);
      }
    }

    function showForm(tag) {
      if (!vm.formActive) {
        if (tag) {
          tag.showEditForm = true;
        } else {
          vm.showAddNewForm = true;
        }
        vm.activeActionTagId = false;
        vm.formActive = true;
      }
    }

    function hideForm(event, tag) {
      if (tag) {
        tag.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
    }

    function updateTag($event) {
      openCodeSnippet($event.tag);
      vm.onUpdate();
    }

    function confirmDeleteTag() {
      return callTrackingTagService.deleteCallTrackingTag(accountsService.currentAccountId, vm.tagForDelete.campaignId, vm.tagForDelete.publisherId, vm.tagForDelete.numberId).
        then(function() {
          cancelModal();
          toaster.pop('success', $translate.instant('CALL_TRACKING_TAGS_DELETE_SUCCESSFUL'));
          vm.onUpdate();
        });
    }

    function cancelDelete() {
      cancelModal();
    }

    function confirmDeleteModal(tag) {
      if (!vm.formActive) {
        vm.tagForDelete = tag;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/call-tracking-tag/delete-call-tracking-tag.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function openCodeSnippet(tag) {
      if (!vm.formActive) {
        vm.snippetJSTag = tag;
        vm.toggleStatus = {
          oneLinerOpen: true,
          longSnippetOpen: false
        };

        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/js-tag-code-snippet/snippets.modal.html',
          scope: $scope,
          controllerAs: 'vm',
          size: 'lg'
        });
      }
    }

    function cancelModal() {
      vm.modal.close();
      vm.modal = null;
      vm.tagForDelete = null;
    }

    function activateTagActions(tagId) {
      if (!vm.formActive) {
        vm.activeActionTagId = vm.activeActionTagId == tagId ? false : tagId;
      }
    }

    function _setTags(tags) {
      vm.tags = tags;
      vm.setCampaignTags({ jsTags: tags });
    }
  }
})();
